<template>
    <div class="table-layout">
        <el-table :data="callBidDocNoticeList" border style="width: 100%">
            <el-table-column prop="title" label="发布名称" width="200" show-overflow-tooltip></el-table-column>
            <el-table-column prop="publishTime" label="发布时间" width="200"></el-table-column>
            <el-table-column prop="createTime" label="创建时间" width="180"></el-table-column>
            <el-table-column label="操作">
                <template slot-scope="scope">
                    <a class="swb-btn-link" @click="lookNotice(scope.row.id)">查看</a>
                </template>
            </el-table-column>
        </el-table>
    </div>
</template>

<script>

    import { Utils } from '../../app.base'
    import { Vue, MsgBox, Routes } from '../../app.vues'

    import callBidApi from '../../api/callBid'

    import SwbCallBidNoticeSave from './CallBidNoticeSave';
    Vue.regist(SwbCallBidNoticeSave);

    export default {
        name: 'swb-call-bid-notice-list',
        desc: '招标公告列表',
        props: ['docId'],
        data: function () {
            return {
                callBidDocNoticeList: [],
            }
        },
        created: function () {
            this.getCallBidNoticeList();
        },
        methods: {
            getCallBidNoticeList: function () {
                let self = this;
                let paramsData = {};
                paramsData.docId = self.docId;
                let theLoad = MsgBox.loading();
                callBidApi.getCallBidNoticeListByDocId(paramsData, function (result) {
                    theLoad.hide();
                    if(result.type === "info") {
                        let data = result.data;
                        self.callBidDocNoticeList = data;
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            lookNotice: function (id) {
                let paramsData = {};
                paramsData.id = id;
                callBidApi.getCallBidNotice(paramsData, function (result) {
                    if(result.type == "info") {
                        let callBidDocNotice = result.data;
                        Vue.$showDialog({
                            title: '查看 - 公告',
                            showCloseBtn: true,
                            width: 1000,
                            height: 700,
                            template: '<div>' +
                            '<swb-call-bid-notice-save :content="content" :id="id" add="true" ref="swb_call_bid_notice"></swb-call-bid-notice-save>' +
                            '</div>',
                            data: {
                                id: id,
                                add: true,
                                content: null,
                            },
                            okClicked: function () {
                            },
                            okVisible: false,
                            method: {},
                            lifecycle: {
                                created: function () {
                                    this.content = callBidDocNotice.content;
                                }
                            }

                        });
                    }

                })

            },

            editCallBidNotic: function (id, docId, add) {
                let self = this;
                Vue.$showDialog({
                    title: '编辑 - 公告',
                    showCloseBtn: true,
                    width: 1200,
                    height: 900,
                    template: '<div>' +
                    '<swb-call-bid-notice-save :add="add" :docId="docId" :id="id" ref="swb_call_bid_notice"></swb-call-bid-notice-save>' +
                    '</div>',
                    data: {
                        docId: docId,
                        id: id,
                        add: add,
                    },
                    extVisible: true,
                    okText: '保存',
                    extText: '发布',
                    extClicked: function () {
                        let result = this.$refs.swb_call_bid_notice.getDlgResult() || {};
                        if(result.type = "info") {
                            let postData = {};
                            postData = result.data;
                            postData.published = true;
                            callbidApi.saveCallBidNotice(postData, function (result) {
                                if(result.type == "info") {
                                    MsgBox.success("保存成功");
                                    self.getCallBidNoticeList();
                                } else {
                                    MsgBox.warning(result.message);
                                }
                            })
                        } else {
                            MsgBox.warning("请添加必须的信息");
                            return false;
                        }
                    },
                    okClicked: function () {
                        let result = this.$refs.swb_call_bid_notice.getDlgResult() || {};
                        if(result.type = "info") {
                            let postData = {};
                            postData = result.data;
                            postData.published = false;
                            callbidApi.saveCallBidNotice(postData, function (result) {
                                if(result.type == "info") {
                                    MsgBox.success("保存成功");
                                    self.getCallBidNoticeList();
                                } else {
                                    MsgBox.warning(result.message);
                                }
                            });
                            return false;
                        } else {
                            MsgBox.warning("请添加必须的信息");
                            return false;
                        }
                    },
                    method: {},
                    lifecycle: {}
                });
            },

        },
    }

</script>



// WEBPACK FOOTER //
// src/compo/callbid/CallBidNoticeList.vue